function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Component_11",
  "data-name": "Component 11",
  transform: "translate(0.5 0.5)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_355",
  "data-name": "Group 355",
  transform: "translate(-2 -2)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_173",
  "data-name": "Group 173",
  transform: "translate(6.962 9.164)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_5",
  "data-name": "Line 5",
  y1: 1.618,
  x2: 1.618,
  transform: "translate(13.458)",
  fill: "none",
  stroke: "#566FFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_246",
  "data-name": "Path 246",
  d: "M504.514,255.854l4.971,5.41,6.721-7.2",
  transform: "translate(-504.514 -250.593)",
  fill: "none",
  stroke: "#566FFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_331",
  "data-name": "Path 331",
  d: "M875.394,222.15v-5.4h25v25h-25v-15.3",
  transform: "translate(-873.394 -214.747)",
  fill: "none",
  stroke: "#566FFF",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1
})));

var SvgJoratoCasesCompletedLightBlue = function SvgJoratoCasesCompletedLightBlue(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgJoratoCasesCompletedLightBlue, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/jorato-cases-completed-light-blue.2214e243.svg";
export { ForwardRef as ReactComponent };